import React, { useState } from 'react';
import {
  Box, Button,Modal, Typography, TextField, MenuItem, FormControl, InputLabel, Select, Grid, IconButton, Checkbox, FormControlLabel, Tooltip
} from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import FilterAltOffRoundedIcon from '@mui/icons-material/FilterAltOffRounded';
import { useSelector } from 'react-redux';
import { format } from 'date-fns';
import { filterAvanceTask,filterAvanceTaskUsers } from '../../store/grupo.actions';
import DeleteIcon from '@mui/icons-material/Delete';
import {loadGroupsWithUactividades } from "../../store/grupo.actions";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import 'dayjs/locale/es';  // Importa el idioma español de dayjs

const FilterModal = ({ open, onUpdate, handleClose }) => {
  const [activeFilters, setActiveFilters] = useState([]);
  const currentBoard = useSelector((storeState) => storeState.boardModule.currentBoard);
  dayjs.locale('es');
  const [availableFilters, setAvailableFilters] = useState([
    { value: 'startDate', label: 'Fechas' },
    { value: 'responsable', label: 'Responsable' },
    { value: 'proyecto', label: 'Proyecto' },
    { value: 'estado', label: 'Estado' },
  ]);
  const [selectedFilter, setSelectedFilter] = useState('');
  const [filterValues, setFilterValues] = useState({
    startDate: null,
    endDate: null,
    selectedUser: '',
    selectedProject: '',
    selectedEstado: '',
  });
  const [checkboxChecked, setCheckboxChecked] = useState(false); // Para el checkbox
  const [filterStatus, setFilterStatus] = useState('Normal');

  const members = useSelector(storeState => storeState.userModule.users);
  
  // Obtiene los proyectos de la base de datos
  const DataInfo = useSelector(storeState => storeState.infoModulo.infoM);
  const projectData = DataInfo?.projectOptions || [];  // Si no hay datos, se usa un arreglo vacío
  const StatusOptions = DataInfo?.statusOptions || [];




  const removeFilter = (filterToRemove) => {
    // Primero, eliminamos el filtro activo
    setActiveFilters(activeFilters.filter(filter => filter.value !== filterToRemove));
  
    // Luego, agregamos el filtro eliminado a los filtros disponibles
    setAvailableFilters([...availableFilters, { value: filterToRemove, label: getFilterLabel(filterToRemove) }]);
  
    // Limpiamos los valores asociados a este filtro
    setFilterValues(prevValues => ({
      ...prevValues,
      [filterToRemove === 'startDate' ? 'startDate' : 
       filterToRemove === 'endDate' ? 'endDate' : 
       filterToRemove === 'responsable' ? 'selectedUser' :
       filterToRemove === 'estado' ? 'selectedEstado' : 
       filterToRemove === 'proyecto' ? 'selectedProject' : '']: 
      filterToRemove === 'startDate' ? null : '' // Limpia el valor de inicio o final
    }));
  };

    // Automáticamente agrega el filtro cuando se selecciona
    const handleSelectFilter = (e) => {
      const selectedValue = e.target.value;
      if (selectedValue && !activeFilters.find(filter => filter.value === selectedValue)) {
        const newFilter = availableFilters.find(filter => filter.value === selectedValue);
        setActiveFilters([...activeFilters, newFilter]);
        setAvailableFilters(availableFilters.filter(filter => filter.value !== selectedValue));
        setSelectedFilter('');
      }
    };



  

  const getFilterLabel = (filterValue) => {
    switch (filterValue) {
      case 'startDate':
        return 'Fecha de Inicio';
      case 'responsable':
        return 'Responsable';
      case 'proyecto':
        return 'Proyecto';
      case 'estado':
        return 'Estado';
      default:
        return '';
    }
  };

  const handleFilterChange = (filter, value) => {
    setFilterValues({
      ...filterValues,
      [filter]: value
    });
  };

  const applyFilters = async () => {
    const { startDate, endDate, selectedProject,selectedEstado, selectedUser } = filterValues;
    const formattedStartDate = startDate ? format(new Date(startDate), 'yyyy/MM/dd') : null;
    const formattedEndDate = endDate ? format(new Date(endDate), 'yyyy/MM/dd') : null;
  
    const formData = {
      ...(formattedStartDate && { fecha_inicio: formattedStartDate }),
      ...(formattedEndDate && { fecha_final: formattedEndDate }),
      ...(selectedProject && { fk_proyecto_id: selectedProject }),
      ...(selectedEstado && { fk_estado_id: selectedEstado }),
      ...(selectedUser && { fk_usuario_id: selectedUser }),
    };

    StartFilter(formData,currentBoard.id_tablero, selectedUser,filterStatus);

    Onstatus(true);


  };


async function StartFilter(formData, idTablero, idResponsable, statusFilter) {
  if(idResponsable){
    await filterAvanceTaskUsers(formData, idTablero,idResponsable, statusFilter);

  } else {
    // Si no hay un responsable, realiza el filtro normal
    await filterAvanceTask(formData, idTablero, statusFilter);
  }
}



 // Checkbox para filtrar por rango de fechas
const handleCheckboxChange = (event) => {
  setCheckboxChecked(event.target.checked);
  setFilterStatus(event.target.checked ? "Rango" : "Normal");
};

  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90%',
    maxWidth: 600, // Ajustar el tamaño del modal aquí
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    borderRadius: 3,
  };

  const handleClearFilter = () => {
    // Limpiar los valores de los filtros
    setFilterValues({
      startDate: null,
      endDate: null,
      selectedUser: '',
      selectedProject: '',
      selectedEstado: '',
    });
  
    // Restablecer los filtros seleccionados y activos
    setSelectedFilter('');
    setActiveFilters([]);
  
    // Hacer disponibles todos los filtros nuevamente
    setAvailableFilters([
      { value: 'startDate', label: 'Fechas' },
      { value: 'responsable', label: 'Responsable' },
      { value: 'proyecto', label: 'Proyecto' },
      { value: 'estado', label: 'Estado' },
    ]);
  
    // Desmarcar el checkbox
    setCheckboxChecked(false);
  
    // Restablecer el estado de filtro
    setFilterStatus('Normal');

    loadGroupsWithUactividades(currentBoard.id_tablero);
    Onstatus(false);

  };

//funcion para cambiar la apariecia del filtro avanzado
  function Onstatus(estado) {
    onUpdate(estado);
}
  



  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={modalStyle}>
        <Typography variant="h6" mb={2}>Seleccionar Filtros:</Typography>

        <Grid container spacing={2} alignItems="center">
      <Grid item xs={12} sm={6}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}> {/* Flexbox para alinear el Select y el botón */}
          <FormControl sx={{ minWidth: 450 }}> {/* Define el ancho deseado */}
            <InputLabel id="filter-select-label">Seleccionar Filtro</InputLabel>
            <Select
              labelId="filter-select-label"
              value={selectedFilter}
              label="Seleccionar Filtro"
              onChange={handleSelectFilter}
            >
              {availableFilters.map(filter => (
                <MenuItem key={filter.value} value={filter.value}>
                  {filter.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {/* Botón para eliminar el filtro seleccionado */}
          <Tooltip title="Eliminar Filtrado" arrow>
          <IconButton
            style={{ color: 'black' }} // Cambia el color del IconButton
            onClick={handleClearFilter}
          >
            <DeleteIcon sx={{ color: 'black' }} />
          </IconButton>
        </Tooltip>
        </Box>
      </Grid>
    </Grid>

        <Box mt={3}>
        <Grid container spacing={2}>
  {activeFilters.map((filter) => (
    <React.Fragment key={filter.value}>
      <Grid item xs={9} sm={10}>
        {filter.value === 'startDate' && (
          <Grid container spacing={2} alignItems="center">

<Grid item xs={6}>
        {/* Configuramos el provider y adaptamos el idioma español desde dayjs */}
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
          <DatePicker
            label="Fecha de Inicio"
            value={filterValues.startDate}
            onChange={(newValue) => handleFilterChange('startDate', newValue)}
            inputFormat="DD/MM/YYYY"  
            renderInput={(params) => <TextField {...params} fullWidth size="small" />}
          />
        </LocalizationProvider>
      </Grid>

      <Grid item xs={6}>
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
          <DatePicker
            label="Fecha Final"
            value={filterValues.endDate}
            onChange={(newValue) => handleFilterChange('endDate', newValue)}
            inputFormat="DD/MM/YYYY"  
            renderInput={(params) => <TextField {...params} fullWidth size="small" />}
          />
        </LocalizationProvider>
      </Grid>

             
            {filterValues.startDate && filterValues.endDate && (
                        <Grid item xs={12}>
                          <Tooltip title="Filtrar Fechas por Rango">
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={checkboxChecked}
                                  onChange={handleCheckboxChange}
                                />
                              }
                              label="Filtrar por Rango" // Agregar texto al checkbox
                              style={{ marginTop: '-20px', display: 'flex' }} // Alinear el checkbox
                            />
                          </Tooltip>
                        </Grid>
                      )}
            
          </Grid>
        )}


{filter.value === 'responsable' && (
        <FormControl fullWidth size="small">
          <InputLabel id="responsable-label">Responsable</InputLabel>
          <Select
            labelId="responsable-label"
            value={filterValues.selectedUser || ''} // Valor seleccionado
            label="Responsable"
            onChange={(e) => handleFilterChange('selectedUser', e.target.value)}
            MenuProps={{
              PaperProps: {
                style: {
                  maxHeight: 48 * 4.5 + 8,  // Limita la altura a 4.5 elementos
                  overflow: 'auto',         // Habilita desplazamiento (scroll)
                },
              },
            }}
          >
            {members.map((member) => (
              <MenuItem key={member.id_usuario} value={member.id_usuario}>
                {member.nombre}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}


{filter.value === 'proyecto' && (
        <FormControl fullWidth size="small">
          <InputLabel id="proyecto-label">Proyecto</InputLabel>
          <Select
            labelId="proyecto-label"
            value={filterValues.selectedProject || ''}  // Valor seleccionado
            label="Proyecto"
            onChange={(e) => handleFilterChange('selectedProject', e.target.value)}
            MenuProps={{
              PaperProps: {
                style: {
                  maxHeight: 48 * 4.5 + 8,  // Limita la altura a 4.5 elementos
                  overflow: 'auto',         // Habilita desplazamiento (scroll)
                },
              },
            }}
          >
            {projectData.map((project) => (
                <MenuItem
                  key={project.id_proyecto}
                  value={project.id_proyecto}
                  sx={{
                    borderLeft: `8px solid ${project.bgColor}`,  // Borde izquierdo coloreado
                    paddingLeft: '16px',  // Añade espacio para que el borde sea visible
                  }}
                >
                  {project.nombre_proyecto}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      )}


                  {/* apartado por estados  */}
                  {filter.value === 'estado' && (
        <FormControl fullWidth size="small">
          <InputLabel id="estado-label">Estado Actividad</InputLabel>
          <Select
            labelId="estado-label"
            value={filterValues.selectedEstado || ''}  // Valor seleccionado
            label="Estado Actividad"
            onChange={(e) => handleFilterChange('selectedEstado', e.target.value)}
            MenuProps={{
              PaperProps: {
                style: {
                  maxHeight: 48 * 4.5 + 8,  // Limita la altura a 4.5 elementos
                  overflow: 'auto',         // Habilita desplazamiento (scroll)
                },
              },
            }}
          >
            {StatusOptions.map((status) => (
                <MenuItem
                  key={status.id_estado_actividad}
                  value={status.id_estado_actividad}
                  sx={{
                    borderLeft: `8px solid ${status.color}`, // Borde izquierdo coloreado
                    paddingLeft: '16px', // Añade espacio para que el borde sea visible
                  }}
                >
                  {status.descripcion}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      )}



                </Grid>
              <Grid item xs={3} sm={2}>
                <IconButton onClick={() => removeFilter(filter.value)}>
                  <FilterAltOffRoundedIcon />
                </IconButton>
              </Grid>
              </React.Fragment>
            ))}
          </Grid>
        </Box>

        {/* Botón centrado en el modal */}
        <Box mt={3} display="flex" justifyContent="center">
          <Button variant="contained" color="primary" onClick={applyFilters}>
            Aplicar Filtros
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default FilterModal;
